import { Switch } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

import { SettingRow } from "@/components/elements/Settings/SettingRow";

export const NumberFormatter = () => {
  const { t } = useTranslation();

  const [compact, setCompact] = useLocalStorage<boolean>({
    key: "number-formatting",
    defaultValue: true,
  });

  return (
    <SettingRow
      label={t("header.number_format.title")}
      leftSection={t("header.number_format.full")}
      rightSection={t("header.number_format.rounded")}
    >
      <Switch checked={compact} onChange={(event) => setCompact(event.currentTarget.checked)} />
    </SettingRow>
  );
};
